import { render } from "./ElementProperties.vue?vue&type=template&id=e5b6de5c&scoped=true&ts=true"
import script from "./ElementProperties.vue?vue&type=script&lang=ts"
export * from "./ElementProperties.vue?vue&type=script&lang=ts"

import "./ElementProperties.vue?vue&type=style&index=0&id=e5b6de5c&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b6de5c"]])

export default __exports__